export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 border-t border-background-300/30">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold font-heading text-primary-400 mb-3">黑料入口</h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              黑料吃瓜网站与吃瓜黑料网站的首选平台。我们致力于构建最全面的黑料故事库，收录各类黑料事件揭秘与瓜田故事，持续追踪黑料后真相。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/40 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/15 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/40 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/15 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/40 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/15 transition-colors cursor-pointer">
                <i className="ri-vidicon-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '首页', href: '#hero' },
                { label: '专题合集', href: '#index' },
                { label: '热度榜单', href: '#ranking' },
                { label: '瓜友热评', href: '#comments' },
                { label: '热门话题', href: '#topics' },
                { label: '常见问答', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(link.href);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">热门专题</h4>
            <ul className="space-y-2.5">
              {[
                { label: '娱乐圈黑料', href: '#topics' },
                { label: '网红塌房', href: '#topics' },
                { label: '大厂内幕', href: '#topics' },
                { label: '直播带货', href: '#topics' },
                { label: '社会热点', href: '#topics' },
                { label: '财经黑幕', href: '#topics' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              黑料入口与多家优质内容平台和媒体机构保持合作，共同打造健康有序的吃瓜内容生态。
            </p>
            <h4 className="text-sm font-semibold text-foreground-300 mb-3 mt-5">联系方式</h4>
            <p className="text-xs text-foreground-500">投稿爆料：tips@heiliao.com</p>
            <p className="text-xs text-foreground-500">商务合作：biz@heiliao.com</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; 2026 黑料入口 · 黑料吃瓜网站与吃瓜黑料网站 · 黑料故事揭秘后真相跟踪
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}